/**
 * Produce the SEO-friendly URL for a product page.
 *
 * Format: `/location-{slugified-name}-{numeric-id}`
 *
 * The id is always kept at the end of the path so the backend can resolve
 * the product deterministically even if the name / slug changes over time
 * (avoids broken links after a catalogue rename).
 */
const _accentMap = {
  'à': 'a', 'á': 'a', 'â': 'a', 'ä': 'a', 'ã': 'a', 'å': 'a',
  'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e',
  'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
  'ò': 'o', 'ó': 'o', 'ô': 'o', 'ö': 'o', 'õ': 'o', 'ø': 'o',
  'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u',
  'ý': 'y', 'ÿ': 'y', 'ñ': 'n', 'ç': 'c', '³': '3', '²': '2',
};

export const slugifyName = (name) => {
  if (!name) return 'produit';
  return String(name)
    .toLowerCase()
    .replace(/[àáâäãåèéêëìíîïòóôöõøùúûüýÿñç³²]/g, (c) => _accentMap[c] || c)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80) || 'produit';
};

/**
 * Build the canonical product URL path.
 * @param {{id: string|number, name?: string}} product
 * @returns {string} e.g. "/location-sony-fx6-644"
 */
export const productUrl = (product) => {
  if (!product?.id) return '/catalogue';
  const slug = slugifyName(product.name);
  return `/location-${slug}-${product.id}`;
};

/**
 * Extract the numeric product id from a `location-*-{id}` path.
 * Returns null if no id can be found.
 */
export const extractIdFromSlug = (slugOrPath) => {
  if (!slugOrPath) return null;
  const s = String(slugOrPath).split('?')[0].split('#')[0];
  const m = s.match(/-(\d+)\/?$/);
  return m ? m[1] : null;
};
